import { render, staticRenderFns } from "./EditRoleNameDialog.vue?vue&type=template&id=49ccf418&"
import script from "./EditRoleNameDialog.vue?vue&type=script&lang=js&"
export * from "./EditRoleNameDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports